import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation EmailTest($uid: String!){
        email_test (uid: $uid) {
            success
        }
    }
`;

export async function emailTest(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ email_test: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.email_test;
}
